import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgApexchartsModule } from 'ng-apexcharts';
import { TagInputModule } from 'ngx-chips';

import { NumberFormaterPipe } from '../shared/pipes/NumberFormaterPipe';
import { ListsService } from '../shared/services/lists.service';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../shared/material.module';
import { TokenInterceptor } from '../shared/interceptors/token.interceptor';
import { RefreshInterceptor } from '../shared/interceptors/refresh.interceptor';
import { AffiliatesComponent } from './affiliates/affiliates.component';
import { BroadcastComponent } from './broadcasts/broadcast/broadcast.component';
import { BroadcastsComponent } from './broadcasts/broadcasts.component';
import { IntegrationSmsComponent } from './integration-sms/integration-sms.component';
import { ViewIntegrationSmsComponent } from './integration-sms/view-integration-sms/view-integration-sms.component';
import { IntegrationSmsSendsComponent } from './integration-sms/integration-sms-sends/integration-sms-sends.component';
import { ViewBroadcastComponent } from './broadcasts/view-broadcast/view-broadcast.component';
import { BroadcastWhatsappComponent } from './broadcasts-whatsapp/broadcast-whatsapp/broadcast-whatsapp.component';
import { BroadcastsWhatsappComponent } from './broadcasts-whatsapp/broadcasts-whatsapp.component';
import { ViewBroadcastWhatsappComponent } from './broadcasts-whatsapp/view-broadcast-whatsapp/view-broadcast-whatsapp.component';
import { CampaignComponent } from './campaigns/campaign/campaign.component';
import { CampaignsComponent } from './campaigns/campaigns.component';
import { SequencesComponent } from './campaigns/sequences/sequences.component';
import { RcsSharedModule } from '../shared/rcs/rcs-shared.module';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AccountConfirmationComponent } from './account-confirmation/account-confirmation.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HelpComponent } from './help/help.component';
import { IntegrationComponent } from './integrations/integration/integration.component';
import { IntegrationsComponent } from './integrations/integrations.component';
import { PostbacksComponent } from './integrations/postbacks/postbacks.component';
import { IntegrationActivityComponent } from './integrations/activity/activity.component';
import { LayoutModule } from './layout/layout.module';
import { RechargeModalModule } from './wallet/recharge-modal/recharge-modal.module';
import { LeadPostbackComponent } from './leads/lead-postback/lead-postback.component';
import { LeadSequencesComponent } from './leads/lead-sequences/lead-sequences.component';
import { LeadsComponent } from './lists/leads/leads.component';
import { ListComponent } from './lists/list/list.component';
import { ListsComponent } from './lists/lists.component';
import { LoginComponent } from './login/login.component';
import { MessagesComponent } from './messages-report/messages/messages.component';
import { ModalTwilioComponent } from './modal-twilio/modal-twilio.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { PagesRoutingModule } from './pages-routing.module';
import { ModalPixKeyComponent } from './partner-dashboard/modal-pix-key/modal-pix-key.component';
import { PartnerDashboardComponent } from './partner-dashboard/partner-dashboard.component';
import { AccountDrawerComponent } from './partner-dashboard/account-drawer/account-drawer.component';
import { AccountBalanceComponent } from '../shared/components/account-balance/account-balance.component';
import { PartnerManagementComponent } from './partner-management/partner-management.component';
import { PartnerPaymentsComponent } from './partner-payments/partner-payments.component';
import { PasswordResetStartComponent } from './password-reset-start/password-reset-start.component';
import { PasswordResetSuccessComponent } from './password-reset-success/password-reset-success.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { InviteAcceptComponent } from './invite-accept/invite-accept.component';
import { ProfileComponent } from './profile/profile.component';
import { RcsNotifyPrefsComponent } from './profile/rcs-notify-prefs/rcs-notify-prefs.component';
import { AddCreditsComponent } from './recharges/add-credits/add-credits.component';
import { DominioProprioComponent } from './dominio-proprio/dominio-proprio.component';
import { DominioPrecosComponent } from './dominio-proprio/precos/dominio-precos.component';
import { RechargeComponent } from './recharges/recharge/recharge.component';
import { RechargesComponent } from './recharges/recharges.component';
import { ReportsComponent } from './reports/reports.component';
import { SupportFormComponent } from './support-form/support-form.component';
import { ClientsComponent } from './users/clients/clients.component';
import { UserComponent } from './users/user/user.component';
import { UserRcsSettingsComponent } from './admin-rcs/user-rcs-settings/user-rcs-settings.component';
import { UsersComponent } from './users/users.component';
import { ViewPartnerPaymentsComponent } from './view-partner-payments/view-partner-payments.component';
import { LeadResponsesComponent } from './lead-responses/lead-responses.component';
import { FinancialComponent } from './financial/financial.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { AnalyticsCampaignsComponent } from './analytics/campaigns/campaigns.component';
import { AnalyticsCampaignsDetailsComponent } from './analytics/campaigns/detail/detail.component';
import { AnalyticsSalesComponent } from './analytics/sales/sales.component';
import { FunnelPerformanceComponent } from './analytics/funnel-performance/funnel-performance.component';
import { MessagesReportComponent } from './messages-report/messages-report.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ShortUrlAnalysisComponent } from './short-url-analysis/short-url-analysis.component';
import { WhatsappTemplatePickerComponent } from './campaigns/sequences/whatsapp-template-picker/whatsapp-template-picker.component';
import { WhatsappSequenceModalComponent } from './campaigns/sequences/whatsapp-sequence-modal/whatsapp-sequence-modal.component';
import { QuickAgentModalComponent } from './campaigns/sequences/quick-agent-modal/quick-agent-modal.component';
import { AgentTestPanelModule } from './playground-ia/agent-builder/agent-test-panel/agent-test-panel.module';
import { ProviderComponent } from './providers/providers.component';
import { ConsumptionReport } from './consumption-report/consumption-report.component';
import { BroadcastsFilterComponent } from './broadcasts-filter/broadcasts-filter.component';
import { FractionationsComponent } from './fractionations/fractionations.component';
import { FractionationComponent } from './fractionations/fractionation/fractionation.component';
import { SmsValidationComponent } from './sms-validation/sms-validation.component';
import { RedirectSignupComponentComponent } from './redirect-signup-component/redirect-signup-component.component';
import { TutoriaisComponent } from './tutoriais/tutoriais.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MonthPickerComponent } from "../shared/components/month-picker/month-picker.component";
import { PartnerStatisticsComponent } from './partner-statistics/partner-statistics.component';
import { Call4uAudiosComponent } from './call4u-audios/call4u-audios.component';
import { Call4uAudioCreateComponent } from './call4u-audios/call4u-audio-create/call4u-audio-create.component';
import { Call4uAudioEditComponent } from './call4u-audios/call4u-audio-edit/call4u-audio-edit.component';
import { BroadcastsCallComponent } from './broadcasts-call/broadcasts-call.component';
import { BroadcastCallComponent } from './broadcasts-call/broadcast-call/broadcast-call.component';
import { ViewBroadcastCallComponent } from './broadcasts-call/view-broadcast-call/view-broadcast-call.component';
import { EditBroadcastCallComponent } from './broadcasts-call/edit-broadcast-call/edit-broadcast-call.component';
import { LigacoesMetricasComponent } from './ligacoes-metricas/ligacoes-metricas.component';
import { CallsReportComponent } from './calls-report/calls-report.component';
import { CallsComponent } from './calls-report/calls/calls.component';
import { ProviderReportComponent } from './provider-report/provider-report.component';
import { IntegrationTemplatesComponent } from './integrations-templates/integrations-templates.component';
import { IntegrationTemplateEventEditorModalComponent } from './integrations-templates/event-editor-modal/event-editor-modal.component';
import { AppAuthenticationReportComponent } from './app-authentication-report/app-authentication-report.component';
import { AuditLogsComponent } from './audit-logs/audit-logs.component';

@NgModule({
  declarations: [
    CampaignComponent,
    CampaignsComponent,
    ChangePasswordComponent,
    AccountConfirmationComponent,
    DashboardComponent,
    IntegrationComponent,
    IntegrationsComponent,
    LeadsComponent,
    ListsComponent,
    ListComponent,
    LoginComponent,
    NotificationsComponent,
    NumberFormaterPipe,
    DominioProprioComponent,
    DominioPrecosComponent,
    RechargeComponent,
    RechargesComponent,
    SequencesComponent,
    WhatsappTemplatePickerComponent,
    WhatsappSequenceModalComponent,
    QuickAgentModalComponent,
    BroadcastsComponent,
    IntegrationSmsComponent,
    ViewIntegrationSmsComponent,
    IntegrationSmsSendsComponent,
    BroadcastComponent,
    ViewBroadcastComponent,
    BroadcastsWhatsappComponent,
    BroadcastWhatsappComponent,
    ViewBroadcastWhatsappComponent,
    NotFoundComponent,
    UsersComponent,
    UserComponent,
    // Bloco RCS da edição do usuário (17tm466frtx); mora em `admin-rcs/` com o resto do RCS.
    UserRcsSettingsComponent,
    MessagesComponent,
    MessagesReportComponent,
    ReportsComponent,
    PasswordResetComponent,
    InviteAcceptComponent,
    PasswordResetSuccessComponent,
    PasswordResetStartComponent,
    HelpComponent,
    SupportFormComponent,
    AddCreditsComponent,
    AffiliatesComponent,
    PostbacksComponent,
    IntegrationActivityComponent,
    LeadSequencesComponent,
    LeadPostbackComponent,
    PartnerDashboardComponent,
    ModalPixKeyComponent,
    AccountDrawerComponent,
    AccountBalanceComponent,
    PartnerPaymentsComponent,
    ClientsComponent,
    ProfileComponent,
    RcsNotifyPrefsComponent,
    PartnerManagementComponent,
    ViewPartnerPaymentsComponent,
    ModalTwilioComponent,
    LeadResponsesComponent,
    AnalyticsComponent,
    AnalyticsCampaignsComponent,
    AnalyticsCampaignsDetailsComponent,
    AnalyticsSalesComponent,
    FunnelPerformanceComponent,
    FinancialComponent,
    ShortUrlAnalysisComponent,
    ProviderComponent,
    ConsumptionReport,
    BroadcastsFilterComponent,
    FractionationsComponent,
    FractionationComponent,
    SmsValidationComponent,
    RedirectSignupComponentComponent,
    TutoriaisComponent,
    RedirectSignupComponentComponent,
    PartnerStatisticsComponent,
    Call4uAudiosComponent,
    Call4uAudioCreateComponent,
    Call4uAudioEditComponent,
    BroadcastsCallComponent,
    BroadcastCallComponent,
    ViewBroadcastCallComponent,
    EditBroadcastCallComponent,
    LigacoesMetricasComponent,
    CallsReportComponent,
    CallsComponent,
    ProviderReportComponent,
    IntegrationTemplatesComponent,
    IntegrationTemplateEventEditorModalComponent,
    AppAuthenticationReportComponent,
    AuditLogsComponent,
  ],
  imports: [
    CommonModule,
    DragDropModule,
    NgbModule,
    HttpClientModule,
    FormsModule,
    LayoutModule,
    PagesRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    MaterialModule,
    TagInputModule,
    NgApexchartsModule,
    MatTooltipModule,
    MonthPickerComponent,
    // O painel é eager e abre a recarga por valor; o módulo do modal é o menor
    // pedaço da carteira que ele precisa carregar. Ver `RechargeModalModule`.
    RechargeModalModule,
    // Editor RCS da etapa de automação (17tm466frtx), o mesmo do envio em massa.
    RcsSharedModule,
    // O formulário curto de agente do passo de WhatsApp testa o agente (CU-17tm466mg5z).
    AgentTestPanelModule
],
  providers: [
    ListsService,
    // CU-86ak84mj6 — o Refresh vem ANTES do Token de proposito: a requisicao
    // reexecutada depois da renovacao volta a passar pelo TokenInterceptor, que
    // injeta o access token novo ja gravado.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
})
export class PagesModule {}
